// extracted by mini-css-extract-plugin
module.exports = {"container":"AIDocumentGenerationForm_container__kWFPn","containerGenerating":"AIDocumentGenerationForm_containerGenerating__bi4r1"};